import { request } from 'src/editor/shared/utils/request'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export interface ContactField {
  id: number
  fieldName: string
  slug: ContactSlugEnum
}

export const fetchContactFields = async (): Promise<ContactField[]> => {
  const response = await request.get(
    '/api/dashboard/customer/contact/fields/list',
  )
  return response.data.items
}
